import React from "react";
import {useAppSelector} from "../../redux/hooks";
import {settingsStore} from "../../redux/settings/settingsStore";
import {lessonPlayerStore} from "../../redux/lesson/LessonPlayerStore";
import {logger} from "../../services/log/logger";

interface IPitchDetectionDebuggingProps {
  isPitchDetectionEnabled: boolean;
}

export default function PitchDetectionDebugging({isPitchDetectionEnabled}: IPitchDetectionDebuggingProps) {
  const isPitchDetectionDebuggingEnabled = useAppSelector(settingsStore.getIsPitchDetectionDebuggingEnabled);
  const isFeedbackEnabled = useAppSelector(lessonPlayerStore.getIsInstantFeedbackEnabled);
  const isDemoSoundEnabled = useAppSelector(() => {
    return lessonPlayerStore.getIsDemoLeftHandSoundEnabled() || lessonPlayerStore.getIsDemoRightHandSoundEnabled();
  });

  if (!isPitchDetectionDebuggingEnabled) {
    return null;
  }

  logger.pitchDetection.info({
    message: "LessonPage: Rendering UI components...",
    showStack: false,
    data: [
      {key: "isPitchDetectionEnabled", value: isPitchDetectionEnabled},
      {key: "isPitchDetectionDebuggingEnabled", value: isPitchDetectionDebuggingEnabled},
      {key: "isFeedbackEnabled", value: isFeedbackEnabled},
      {key: "isDemoSoundEnabled", value: isDemoSoundEnabled},
    ]
  });

  return (
    <div style={{flexDirection: "row"}}>
      {getIndicator("pitch-detection-is-enabled", isPitchDetectionEnabled, "PD")}
      {getIndicator("pitch-detection-debugging-is-enabled", isPitchDetectionDebuggingEnabled, "PD Debug")}
      {getIndicator("keyboard-is-plugged-in", false, "K")}
      {getIndicator("selected-keyboard-is-plugged-in", false, "K Selected")}
      {getIndicator("feedback-is-enabled", isFeedbackEnabled, "F")}
      {getIndicator("demo-mode-is-enabled", isDemoSoundEnabled, "D")}
    </div>
  );
}

const getIndicator = (id: string, isEnabled: boolean, code: string = "") => {
  return <div
    style={{
      marginRight: "6px",
      width: "fit-content",
      borderStyle: "solid",
      borderColor: "black",
      borderWidth: "1px",
      display: "inline-block",
      backgroundColor: isEnabled ? "green" : "white",
      color: isEnabled ? "white" : "black",
      padding: "2px",
    }}
    id={id}>
    {code}
  </div>;
};